import { useEffect, type ReactNode } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { ArrowLeft, FolderSearch, LogOut, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUser } from '@/store/useUser';
import { MedcallSessionTimeout } from '@/pages/medcall/MedcallSessionTimeout';
import '@/pages/medcall/medcallLegacy.css';
import { ProfileMedcallClientsPage } from './ProfileMedcallClientsPage';
import { MedcallParticipantProfileRoute } from './MedcallParticipantProfile';
import { MedcallProfilePage } from './ParticipantProfilePage';
import { ParticipantProfileSearchPage } from './ParticipantProfileSearchPage';

const links = [
  { key: 'my-clients', label: 'My Clients', icon: Users }, { key: 'all-clients', label: 'All Clients', icon: Users },
  { key: 'search', label: 'Participant search', icon: FolderSearch },
];
const SharedMedcall2Frame = ({ children }: { children: ReactNode }) => {
  const { logout } = useUser(); const navigate = useNavigate();
  useEffect(() => {
    document.body.classList.add('medcall-legacy-active');
    return () => document.body.classList.remove('medcall-legacy-active');
  }, []);
  const leave = () => { logout(); navigate('/login', { replace: true }); };
  return <div id="shared-medcall2-page" className="space-y-3">
    <nav aria-label="MedCall navigation" className="flex flex-wrap gap-2 p-4 pb-0">
      <Button asChild variant="outline"><Link id="shared-medcall2-dashboard" to="/dashboard"><ArrowLeft aria-hidden="true" className="mr-2 h-4 w-4" />Main menu</Link></Button>
      {links.map(({ key, label, icon: Icon }) => <Button key={key} asChild variant="outline"><Link id={`shared-medcall2-${key}`} to={`/tools/medcall2/${key}`}><Icon aria-hidden="true" className="mr-2 h-4 w-4" />{label}</Link></Button>)}
      <Button id="shared-medcall2-logout" variant="outline" onClick={leave}><LogOut aria-hidden="true" className="mr-2 h-4 w-4" />Log out</Button>
    </nav>
    {children}
    <MedcallSessionTimeout onLogout={leave} />
  </div>;
};

export const SharedMedcall2LandingRedirect = () => <Navigate to="/tools/medcall2/all-clients" replace />;
export const SharedMedcall2MyClientsPage = () => <SharedMedcall2Frame><ProfileMedcallClientsPage scope="my" routeBase="/tools/medcall2" /></SharedMedcall2Frame>;
export const SharedMedcall2AllClientsPage = () => <SharedMedcall2Frame><ProfileMedcallClientsPage scope="all" routeBase="/tools/medcall2" /></SharedMedcall2Frame>;
export const SharedMedcall2ParticipantPage = () => <SharedMedcall2Frame><MedcallParticipantProfileRoute /></SharedMedcall2Frame>;
export const SharedMedcall2ODRProfilePage = () => <SharedMedcall2Frame><MedcallProfilePage /></SharedMedcall2Frame>;
export const SharedMedcall2SearchPage = () => <SharedMedcall2Frame><ParticipantProfileSearchPage medcall medcallPath="/tools/medcall2/profiles" /></SharedMedcall2Frame>;
